import React, { Ref } from 'react';
import { Select as AntDSelect, SelectProps as AntDSelectProps } from 'antd';
import { AngleIcon } from 'components/icons';

const { Option } = AntDSelect;

export type SelectOption = {
  value: string;
  label: React.ReactNode;
};

type SelectProps = {
  options?: SelectOption[];
} & AntDSelectProps<string | string[]>;

// eslint-disable-next-line react/display-name, @typescript-eslint/no-explicit-any
export const Select = React.forwardRef((props: SelectProps, ref: Ref<any>) => {
  const options = props.options?.map((option) => (
    <Option key={option.value} value={option.value}>
      {option.label}
    </Option>
  ));

  return (
    <AntDSelect
      {...props}
      suffixIcon={props.suffixIcon || <AngleIcon />}
      ref={ref}
    >
      {options}
    </AntDSelect>
  );
});
